(function(){
  var tiers=[].slice.call(document.querySelectorAll('.tier'));
  var addons=[].slice.call(document.querySelectorAll('.addon'));
  var totalEl=document.getElementById('total');
  var qtyInput=document.getElementById('qty');
  var qtyCov=document.getElementById('qtycov');
  var corrBox=document.getElementById('corrugated');
  var corrRow=document.getElementById('corrRow');
  var subSel=document.getElementById('substrate');

  function money(n){return '$'+n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
  function qty(){ return Math.max(1,parseInt(qtyInput.value,10)||1); }
  function corrFactor(){ return (corrBox&&corrBox.checked)?1.25:1; }

  function recalc(){
    var t=document.querySelector('.tier.on');
    var sum=t?parseFloat(t.dataset.price)*qty():0;
    addons.forEach(function(a){
      if(a.hasAttribute('hidden')) return;
      var cb=a.querySelector('input[type="checkbox"]');
      if(cb&&cb.checked) sum+=parseFloat(cb.dataset.price||0)*(a.aQty?a.aQty():1);
    });
    totalEl.textContent=money(sum);
    if(t&&qtyCov){
      qtyCov.textContent='covers up to '+(parseInt(t.dataset.cov,10)*qty()).toLocaleString()+' sq ft';
    }
  }

  qtyInput.addEventListener('input',recalc);
  [].slice.call(document.querySelectorAll('.qty > .qty__b')).forEach(function(b){
    b.addEventListener('click',function(){
      qtyInput.value=Math.min(99,Math.max(1,qty()+parseInt(b.dataset.step,10)));
      recalc();
    });
  });

  tiers.forEach(function(t){
    t.addEventListener('click',function(){
      tiers.forEach(function(x){x.classList.remove('on');});
      t.classList.add('on');
      var r=t.querySelector('input'); if(r) r.checked=true;
      recalc();
    });
  });

  // ---- add-on rows ----
  addons.forEach(function(a){
    var cb=a.querySelector('input[type="checkbox"]');
    var sel=a.querySelector('.addon__sel');
    var priceEl=a.querySelector('.addon__p');
    var fromLabel=priceEl?priceEl.textContent:'';
    var qtyWrap=a.querySelector('.addon__qty');
    var qtyField=a.querySelector('.addon__q');
    a.aQty=function(){ return qtyField?Math.max(1,parseInt(qtyField.value,10)||1):1; };

    if(qtyWrap){
      qtyWrap.addEventListener('click',function(e){e.stopPropagation();});
      [].slice.call(qtyWrap.querySelectorAll('.qty__b')).forEach(function(b){
        b.addEventListener('click',function(e){
          e.preventDefault(); e.stopPropagation();
          qtyField.value=Math.min(99,Math.max(1,a.aQty()+parseInt(b.dataset.step,10)));
          recalc();
        });
      });
      qtyField.addEventListener('click',function(e){e.stopPropagation();});
      qtyField.addEventListener('input',function(e){e.stopPropagation();recalc();});
    }

    if(cb){
      cb.addEventListener('change',function(){
        if(this.checked && sel && !sel.value){ this.checked=false; sel.focus(); return; }
        a.classList.toggle('on',this.checked);
        if(!this.checked && sel){ sel.value=''; sel.dispatchEvent(new Event('change')); return; }
        recalc();
      });
    }

    if(sel){
      sel.addEventListener('click',function(e){e.stopPropagation();});
      sel.addEventListener('change',function(e){
        e.stopPropagation();
        var opt=this.options[this.selectedIndex];
        var chosen=!!this.value;
        cb.dataset.price=chosen?(opt.dataset.price||0):0;
        if(opt.dataset.variant) cb.dataset.variant=opt.dataset.variant;
        cb.checked=chosen;
        a.classList.toggle('on',chosen);
        if(qtyWrap){
          if(chosen){qtyWrap.removeAttribute('hidden');}
          else {qtyWrap.setAttribute('hidden',''); if(qtyField) qtyField.value=1;}
        }
        if(priceEl) priceEl.textContent=chosen?('$'+parseFloat(opt.dataset.price).toFixed(2)):fromLabel;
        recalc();
      });
    }
  });

  // ---- substrate drives prep + corrugated ----
  var prepRows={power:document.querySelector('.prep--power'),
                nulift:document.querySelector('.prep--nulift'),
                stone:document.querySelector('.prep--stone')};
  var prepHint=document.getElementById('prepHint');

  function clearRow(row){
    if(!row) return;
    var sel=row.querySelector('.addon__sel');
    if(sel && sel.value){ sel.value=''; sel.dispatchEvent(new Event('change')); }
  }

  // Official SEMCO Surface Preparation Guide:
  //   A = Stone Soap only                 B = Power Cleaner + Stone Soap
  //   C = Power Cleaner + Nu-Lift         D = Nu-Lift + Stone Soap
  //   E = sand with 60-grit, no cleaner
  var PREP={ A:['stone'], B:['power','stone'], C:['power','nulift'], D:['nulift','stone'], E:[] };

  function applySubstrate(){
    var opt=subSel.options[subSel.selectedIndex];
    var prep=opt?opt.dataset.prep:'';
    var isMetal=opt&&opt.dataset.metal==='1';
    var needed=PREP[prep]||[];

    if(corrRow){
      if(isMetal){ corrRow.removeAttribute('hidden'); }
      else { corrRow.setAttribute('hidden',''); if(corrBox) corrBox.checked=false; corrRow.classList.remove('on'); }
    }

    ['power','nulift','stone'].forEach(function(k){
      var row=prepRows[k]; if(!row) return;
      if(needed.indexOf(k)>-1){ row.removeAttribute('hidden'); }
      else { clearRow(row); row.setAttribute('hidden',''); }
    });

    if(prepHint){
      if(!prep) prepHint.textContent='Choose your surface above and the right cleaner appears here.';
      else if(prep==='E') prepHint.textContent='Timber needs no cleaner — sand with 60-grit for adhesion, then coat (Prep E).';
      else if(prep==='B') prepHint.textContent='Power Cleaner cuts through weathering and grease, then Stone Soap (Prep B).';
      else if(prep==='C') prepHint.textContent='A surface that has been leaking needs the heavy-duty pair — Power Cleaner then Nu-Lift (Prep C).';
      else prepHint.textContent='Metal and weathered concrete need Nu-Lift to lift oxidation, efflorescence and contaminants, then Stone Soap (Prep D).';
    }
    recalc();
  }
  if(subSel) subSel.addEventListener('change',applySubstrate);

  if(corrBox){
    corrBox.addEventListener('change',function(){
      corrRow.classList.toggle('on',this.checked);
      var v=parseFloat(document.getElementById('sqft').value);
      if(v>0) document.getElementById('calcBtn').click();
    });
  }

  // ---- swatches + SRI ----
  var sws=[].slice.call(document.querySelectorAll('.sw'));
  var swname=document.getElementById('swname');
  var sriVal=document.getElementById('sriVal');
  var sriNote=document.getElementById('sriNote');
  function showSri(el){
    var v=el.dataset.sri;
    if(!v){ sriVal.textContent='SRI —'; sriNote.textContent='Not yet tested for solar reflectance'; return; }
    var n=parseInt(v,10);
    sriVal.textContent='SRI '+n;
    sriNote.textContent = n>=57 ? 'Reflects the most solar heat'
                        : n>=38 ? 'Mid-range reflectance'
                        : 'Absorbs more heat — around a black asphalt roof';
  }
  sws.forEach(function(el){
    el.addEventListener('click',function(){
      sws.forEach(function(x){x.classList.remove('on');});
      el.classList.add('on');
      swname.textContent=el.dataset.name;
      showSri(el);
    });
  });

  // ---- calculator: cheapest combination, corrugated-aware ----
  function cheapest(options,area){
    var best=null;
    options.forEach(function(o){
      var cov=parseFloat(o.cov), price=parseFloat(o.price);
      if(!cov||!price) return;
      var packs=Math.ceil(area/cov), cost=packs*price;
      if(!best||cost<best.cost-0.001||(Math.abs(cost-best.cost)<0.001&&cov>best.cov)){
        best={ref:o.ref,label:o.label,cov:cov,price:price,packs:packs,cost:cost};
      }
    });
    return best;
  }
  function fitCleaner(id,area){
    var sel=document.getElementById(id);
    if(!sel) return null;
    var row=sel.closest('.addon');
    if(!row||row.hasAttribute('hidden')) return null;
    var opts=[].slice.call(sel.options).filter(function(o){return o.dataset.cov;})
      .map(function(o){return {ref:o,cov:o.dataset.cov,price:o.dataset.price,label:o.textContent.split(' — ')[0]};});
    var best=cheapest(opts,area);
    if(!best) return null;
    sel.selectedIndex=[].slice.call(sel.options).indexOf(best.ref);
    sel.dispatchEvent(new Event('change'));
    var qf=row.querySelector('.addon__q');
    if(qf) qf.value=best.packs;
    return best;
  }

  document.getElementById('calcBtn').addEventListener('click',function(){
    var raw=parseFloat(document.getElementById('sqft').value);
    var out=document.getElementById('calcout');
    if(!raw||raw<=0){out.textContent='Enter your roof area in square feet.';out.classList.add('on');return;}
    if(subSel && !subSel.value){
      out.innerHTML='<strong>Choose your roof surface first</strong> — it decides which cleaner you need.';
      out.classList.add('on'); subSel.focus(); return;
    }

    var f=corrFactor();
    var area=raw*f;

    var tierOpts=tiers.map(function(t){return {ref:t,cov:t.dataset.cov,price:t.dataset.price,label:t.dataset.size};});
    var mem=cheapest(tierOpts,area);
    tiers.forEach(function(x){x.classList.remove('on');});
    mem.ref.classList.add('on');
    var r=mem.ref.querySelector('input'); if(r) r.checked=true;
    qtyInput.value=mem.packs;

    var pc=fitCleaner('power',area), nl=fitCleaner('nulift',area), ss=fitCleaner('stonesoap',area);

    function line(name,b){ return b?('<li>'+name+': <strong>'+(b.packs>1?b.packs+' × ':'')+b.label+'</strong></li>'):''; }
    var html='';
    if(f>1){
      html+='<strong>'+raw.toLocaleString()+' sq ft</strong> footprint → <strong>'+
            Math.round(area).toLocaleString()+' sq ft</strong> of actual surface on corrugated profile.';
    } else {
      html+='<strong>'+raw.toLocaleString()+' sq ft</strong> at two coats.';
    }
    html+='<ul>'+line('Membrane',mem)+line('Power Cleaner',pc)+line('Nu-Lift Cleaner',nl)+line('Stone Soap',ss)+'</ul>';
    html+='<span style="font-size:13.5px;opacity:.75;font-style:italic">Add Fabric Reinforcement for your seams and penetrations — the length depends on how many joints you have, so we haven\'t guessed.</span>';
    out.innerHTML=html;
    out.classList.add('on');
    recalc();
  });

  // ---- reviews toggle ----
  var moreBtn=document.getElementById('moreRevs');
  if(moreBtn){
    moreBtn.addEventListener('click',function(){
      var hidden=[].slice.call(document.querySelectorAll('.revmore'));
      var open=!hidden[0].hasAttribute('hidden');
      hidden.forEach(function(r){ if(open){r.setAttribute('hidden','');} else {r.removeAttribute('hidden');} });
      moreBtn.textContent=open?'Show 10 more reviews':'Show fewer reviews';
    });
  }

  // ---- review photo lightbox ----
  var lbox=document.getElementById('lbox'), lboxImg=document.getElementById('lboxImg');
  [].slice.call(document.querySelectorAll('.revpic')).forEach(function(b){
    b.addEventListener('click',function(){
      lboxImg.src=b.dataset.full; lboxImg.alt=b.querySelector('img').alt;
      lbox.classList.add('on');
    });
  });
  if(lbox){
    lbox.addEventListener('click',function(){ lbox.classList.remove('on'); lboxImg.src=''; });
    document.addEventListener('keyup',function(e){
      if(e.key==='Escape'&&lbox.classList.contains('on')){ lbox.classList.remove('on'); lboxImg.src=''; }
    });
  }

  // ---- sticky bar ----
  var hero=document.querySelector('.hero'), buy=document.getElementById('product'), sticky=document.getElementById('sticky');
  function onScroll(){
    var past=window.scrollY>hero.offsetHeight;
    var rect=buy.getBoundingClientRect();
    sticky.classList.toggle('on', past && !(rect.top<window.innerHeight && rect.bottom>0));
  }
  window.addEventListener('scroll',onScroll,{passive:true});

    // ---- live variant data + add to cart ----
  var variantData=[];
  var blobEl=document.getElementById('lpr-variants');
  if(blobEl){ try{ variantData=JSON.parse(blobEl.textContent)||[]; }catch(e){ variantData=[]; } }

  function findVariant(color,size){
    for(var i=0;i<variantData.length;i++){
      var v=variantData[i];
      if(v.option1===color && v.option2===size) return v;
    }
    return null;
  }
  function currentColor(){ var el=document.querySelector('.sw.on'); return el?el.dataset.name:null; }
  function currentVariant(){
    var t=document.querySelector('.tier.on');
    return (t&&currentColor())?findVariant(currentColor(),t.dataset.size):null;
  }

  function syncPrices(){
    if(!variantData.length) return;
    var color=currentColor();
    tiers.forEach(function(t){
      var v=findVariant(color,t.dataset.size), el=t.querySelector('.tier__p');
      if(v){
        t.dataset.price=(v.price/100).toFixed(2);
        if(el) el.textContent='$'+(v.price/100).toFixed(2);
        t.classList.toggle('soldout', v.available===false);
      }
    });
    recalc();
  }

  var atcBtn=document.getElementById('addToCart');
  var atcNote=document.getElementById('atcNote');
  function note(msg,isErr){
    if(!atcNote) return;
    atcNote.textContent=msg||'';
    if(isErr){atcNote.setAttribute('data-err','1');} else {atcNote.removeAttribute('data-err');}
  }

  if(atcBtn){
    atcBtn.addEventListener('click',function(){
      if(!variantData.length){ note('Product not connected yet - choose the main product in the theme customizer.',true); return; }
      var v=currentVariant();
      if(!v){ note('That color and size combination is not available.',true); return; }
      if(v.available===false){ note('That option is currently out of stock.',true); return; }

      var items=[{id:v.id,quantity:qty()}];
      addons.forEach(function(a){
        if(a.hasAttribute('hidden')) return;
        var cb=a.querySelector('input[type="checkbox"]');
        if(!cb||!cb.checked||!cb.dataset.variant) return;
        items.push({id:Number(cb.dataset.variant),quantity:(a.aQty?a.aQty():1)});
      });

      atcBtn.disabled=true; note('Adding to cart...');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:items})})
      .then(function(r){ return r.json().then(function(d){ if(!r.ok) throw new Error(d.description||d.message||'Could not add to cart.'); return d; }); })
      .then(function(){ window.location='/cart'; })
      .catch(function(err){ atcBtn.disabled=false; note(err.message,true); });
    });
  }

  sws.forEach(function(el){ el.addEventListener('click',syncPrices); });
  syncPrices();
  applySubstrate(); onScroll(); recalc();
})();
